module.exports = __webpack_public_path__ + "img/bar_2.985131e3.png";